<template>

</template>
<script>
  export default{
    data(){
      return {
        jsonp:require('jsonp'),
        key:'',
        title:'',
        cid:'',
        filterBody:false,
        type:'',
        baseParam:'ali=1&normal=1',
        classParam:'',
        keyParam:'',
        filterParam:'dpyhq=false',
        orderParam:'',
        cidParam:'',
        pageNumParam:'',
        resert:false,
        reload:false,
        classIdx:{
          onePrice:3,
//          chaozhi:9,
//          top:24
//          onePrice:602,
          chaozhi:601,
          // top:1492
          top:1221 // 旧排行榜女（6个商品）
        }
      }
    },
    created(){

    },
    mounted(){
    },
    methods:{
      clearParam(){
        this.classParam='';
        this.keyParam='';
        this.filterParam='dpyhq=false';
        this.orderParam='';
        this.cidParam='';
        this.pageNumParam='';
      },
      getParam(){
        let getParam = function(param){
          if(param && param!=''){
            return "&"+param;
          }else{
            return "";
          }
        };
        return this.baseParam
          +getParam(this.classParam)
          +getParam(this.keyParam)
          +getParam(this.filterParam)
          +getParam(this.orderParam)
          +getParam(this.cidParam)
          +getParam(this.pageNumParam)
      },
      toggleResert(){
        this.resert = !this.resert;
      },
      toggleReload(){
        this.reload = !this.reload;
      },
      getTaoPid(tao){
        let self = this;
        let pid = "mm_110646358_17186487_64068451";
        let accountId = tao.accountId;
        let result = pid;
        switch (accountId) {
          case 2:
          case 3:
          case 4:
          case 5: {
            if (self.$cookie.get("PID" + accountId)) {
              result = self.$cookie.get("PID" + accountId);
            } else {
              if (self.$cookie.get("PID")) {
                result = self.$cookie.get("PID")
              } else {
                result = pid;
              }
            }
            break;
          }
          default: {
            if (self.$cookie.get("PID")) {
              result = self.$cookie.get("PID")
            } else {
              result = pid;
            }
            break;
          }
        }
        return result;
      },
      gotoDetail(item,type,idx){
        let seft = this;
        let callback = function(data){
            if(item.Quan_time){
              location.href = seft.weixin(data.couponLink,item,type);
            }else{
              if(data.couponLink && data.couponLink!=''){
                location.href = seft.weixin(data.couponLink,item,type);
              }else{
                seft.http.get(seft.https.getClick+seft.getTaoPid({accountId:1})+"?click="+window.encodeURIComponent(item.ali_click)).then(function(response){
                  if(response.data && response.data.url!=''){
                    location.href = seft.weixin(response.data.url,item,type);
                  }else{
                    location.href = seft.weixin(item.ali_click,item,type);
                  }
                }).catch(function(error){
                  console.error(error);
                });
              }
            }
        };
        this.count(callback,item,'d',type,item.page,idx);
      },
      count(fun,item,t,pageType,cpage,idx){
        let uid = this.$cookie.get("TUID");
        let createTime = this.$cookie.get("TUIDT");
        let unionId = this.getCookie("unionId");
        var url = this.https.count+"?tact="+t+"&ali=1"+(unionId?("&unionId="+unionId):"");
        if(typeof uid!='undefined' && uid!=null){
          url = url+"&uid="+uid;
        }
        if(typeof createTime!='undefined' && createTime!=null){
          url = url+"&createTime="+createTime;
        }
        if(typeof item!='undefined'){
          url = url+"&GoodsID="+item.GoodsID+"&title="+window.encodeURIComponent(item.Title)+"&source="+item.sourceType;
          if(item.sourceType==7){
            url = url +"&ali=1";
          }
          if(!item.Quan_time){
            url = url+"&coupon=n";
          }
        }
        if(typeof idx!='undefined'){
          url = url +"&cidx="+idx;
        }
        if(typeof this.key!='undefined' && this.key!=''){
          url = url +"&k="+window.encodeURIComponent(this.key);
        }
        if(typeof cpage!='undefined'){
          url = url +"&cpage="+cpage;
        }
        if(typeof this.getParam()!='undefined'){
          url = url+"&params="+window.encodeURIComponent(cpage+"?"+this.getParam());
        }
        if(typeof item!='undefined' && !item.Quan_time){
          url = url+"&noCoupons=1";
        }
        var isCallback = true;
        console.log("page type" + pageType)
        switch (parseInt(pageType)){
          case this.headType.searchResultHead:{
//            url = url+"&pagetype=search";
//            break;
          }
          case this.headType.recommend:{

          }
          case this.headType.cidHead:{
//            url = url+"&pagetype=category";
//            break;
          }
          case this.headType.h5Main :{
            if(item && (item.sourceType == 70 || item.sourceType == 71)) {
              isCallback = false;
              var tURL = this.https.count + "?tact=dd&pddSource=mp&GoodsID=" + item.GoodsID; // 拼多多
              this.http.get(tURL).then(
                function (response) {
                  console.log("response.data.couponLink = " + response.data.couponLink);
                  var couponLink = response.data.couponLink;
                  if (couponLink) {
                    url = couponLink;
                  } else if (item.Quan_link) {
                    url = item.Quan_link;
                  } else {
                    url = item.ali_click;
                  }
                  window.location.href = url;
                }
              ).catch(
                function (error) {
                  console.error(error);
                  if (item.Quan_link) {
                    url = item.Quan_link;
                  } else {
                    url = item.ali_click;
                  }
                  window.location.href = url;
                }
              );
            } else if (item && (item.sourceType == 50 || item.sourceType == 51)) { // 京东处理
              isCallback = false;
              var tURL = this.https.count + "?tact=dj&GoodsID=" + item.GoodsID; // JD 50 跳转处理
              if (item.sourceType == 51) tURL += "&jdCouponLink=" + item.Quan_link; // JD 51 跳转处理
              this.http.get(tURL).then(
                function (response) {
                  console.log("response.data.couponLink = " + response.data.couponLink);
                  var couponLink = response.data.couponLink;
                  if (couponLink) {
                    url = couponLink;
                  } else if (item.Quan_link) {
                    url = item.Quan_link;
                  } else {
                    url = item.ali_click;
                  }
                  window.location.href = url;
                }
              ).catch(
                function (error) {
                  console.error(error);
                  if (item.Quan_link) {
                    url = item.Quan_link;
                  } else {
                    url = item.ali_click;
                  }
                  window.location.href = url;
                }
              );
            } else if (item && item.sourceType != 50 && item.sourceType != 51 && item.sourceType != 70 && item.sourceType != 71) {
              url = this.https.mpGoodsDetail;
              url += "&GoodsID=" + item.GoodsID;
              this.getCookie("unionId") && (url += "&unionId=" + this.getCookie("unionId"));
              //url += "&partnerUnionId="+;
              //url += "&channel="+;
              url += "&goodsPic=" + encodeURIComponent(this.updatePicSrc(item.Pic));
              item.shopDetail && item.shopDetail.shopIcon && (
                url += "&shopIcon=" + item.shopDetail.shopIcon.replace("http:", "").replace("https:", "")
              );
              item.shopDetail && item.shopDetail.shopName && (
                url += "&shopName=" + encodeURIComponent(goodsRes.shopDetail.shopName)
              );
              url += "&IsTmall=" + item.IsTmall;
              url += "&Title=" + item.Title;
              url += "&Price=" + item.Price;
              url += "&Quan_price=" + item.Quan_price;
            } else {
              url = url + "&pagetype=main";
            }
            break;
          }
          case this.headType.recommendMain:{

          }
          default:{

          }
        }
        if (isCallback) {
          if(url.indexOf(window.location.origin + "/assets/web/mpWeb/mpGoodsDetail.html") > -1){
            window.location.href = url;
          }else{
            this.http.get(url,{withCredentials: true}).then(function(response){
              if(typeof fun=='function'){
                fun(response.data);
              }
            }).catch(function(error){
              console.error(error);
            });
          }
        }
      },
      weixin(url,item,type){
        let finnalUrl = url;
        if(typeof url=='undefined' || url==''){
          finnalUrl=item.ali_click.replace(/pid=[^&]*/, "pid=" + this.getTaoPid({accountId:1}))
        }else{
          finnalUrl = url.replace(/&nowake=\d/,"");
        }
        if(this.isWeixin){
//          console.log("isweixin")
//          console.log(this.weiXinConfig+item.uuid + "&goodsId=" + item.GoodsID +"#"+finnalUrl)
          if(type==this.headType.wxDetail){
            return this.gotoWxPage(item.uuid,item.GoodsID,finnalUrl);
          } else if(type==this.headType.wxQun){
            return this.https.jumpoutwx+"?url="+window.encodeURIComponent(finnalUrl);
          }
          return this.weiXinConfig+item.uuid + "&goodsId=" + item.GoodsID +"#"+finnalUrl;
        }else{
          return finnalUrl;
        }
      },
      gotoWxPage(uuid,goodsId,url){
        let u = location.href.slice(0,location.href.indexOf("#"))+"#/list";
        if(typeof uuid!='undefined'){
          if(u.indexOf("?")>-1){
            u = u+"&id="+uuid;
          }else{
            u = u+"?id="+uuid;
          }
        }
        if(typeof goodsId!='undefined'){
          if(u.indexOf("?")>-1){
            u = u+"&goodsId="+goodsId;
          }else{
            u = u+"?goodsId="+goodsId;
          }
        }
        if(typeof url!='undefined'){
          if(u.indexOf("?")>-1){
            u = u+"&wx=0&url="+window.encodeURIComponent(url);
          }else{
            u = u+"?wx=0&url="+window.encodeURIComponent(url);
          }
        }
        return u;
      },
      downloadApp(type){
        if(this.isWeixin){
          if(type==this.headType.wxDetail || location.href.indexOf("qweixin.gogoh5.com")>-1){
            let url = location.protocol+"//"+location.hostname+":"+location.port+this.https.downloadApp+"?n=NStmp&f=1";
            if(this.https.downloadApp.indexOf("http")>-1){
              url = this.https.downloadApp+"?n=NStmp&f=1";
            }else{
              url = location.protocol+"//"+location.hostname+":"+location.port+this.https.downloadApp+"?n=NStmp&f=1";
            }
            location.href = this.gotoWxPage(undefined,undefined,url);
          }else{
            location.href='http://a.app.qq.com/o/simple.jsp?pkgname=com.yiqimmm.apps.android';
          }
        }else{
          if(location.hash.toString().indexOf("#Detail") <= -1){
            location.href =this.https.downloadApp+"?type="+this.angentType;
          }else{
            location.href =this.https.downloadApp+"?n=nczFK&f=1";
          }
        }
      },
      gotoShare(type,id,goodsId,isWexin){
        if(typeof isWexin!='undefined'){
          window.location.href = "#/Detail?id="+id+"&goodsId="+goodsId+"&t="+type+"&wx="+isWexin;
        }else{
          window.location.href = "#/Detail?id="+id+"&goodsId="+goodsId+"&t="+type;
        }
      },
      getCookie(key) {
        var coo=decodeURI(document.cookie);//解码
        var arr1=coo.split('; ');//第一次分解后是数组
        for (var i=0;i<arr1.length;i++){//第二次循环拆分数组
          var arr2=arr1[i].split('=');
          if(arr2[0]==key){
            return arr2[1];
          }
        }
      },
      moveTo(){
        try{
          var top = document.getElementsByClassName("top-total")[0].offsetTop;
          var bannerHeight = document.getElementById("banner").offsetTop;
          window.scrollTo(0,top-bannerHeight-2*375/14);
        }catch(e) {
          try{
            let t = document.getElementById("recommend").offsetTop;
            let topH  = document.getElementById("contain-head").offsetTop;
            window.scrollTo(0,topH-t);
          }catch(e){}
        }
      },
      updatePicSrc(pic){
        if(pic){
          let src = pic.replace("http://", "//").replace("https://", "//");
          if (src.indexOf("taobaocdn.") > -1) {
            src = src.split("taobaocdn.")[1];
            src = "//img.alicdn." + src;
          }
          if (src.indexOf("alicdn") > -1) {
            src += "_300x300.jpg";
          }
          return src;
        }
      },
      setCookie(key,value,day) {
        var date=new Date();
        date.setDate(date.getDate()+day);
        document.cookie=key+'='+encodeURI(value)+';expires='+date;
      },
      getCookie(key) {
        var coo=decodeURI(document.cookie);//解码
        var arr1=coo.split('; ');//第一次分解后是数组
        for (var i=0;i<arr1.length;i++){//第二次循环拆分数组
          var arr2=arr1[i].split('=');
          if(arr2[0]==key){
            return arr2[1];
          }
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// Public.vue?7732fe12